import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import * as appConfig from './../../../../app.config';
import { File } from './../../../../models/files/files.model';
import { AlertService } from './../../../services/alert.service';
export const ERROR_MESSAGE = 'Při nahrávání bohužel nastala chyba. Zkuste to prosím později.';

@Component({
  selector: 'swb-mce-dropzone',
  templateUrl: './mce-dropzone.component.html',
  styleUrls: ['./mce-dropzone.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MceDropzoneComponent implements OnInit {
  private _editor: any;

  constructor(private _alertService: AlertService) { }

  ngOnInit() {
    if (top['tinymce']) {
      this._editor = top['tinymce'].activeEditor;
    }
  }

  public uploaded(event) {
    if (event[1].file) {
      const file = event[1].file;

      const uploadedFile = new File({
        id: file.id,
        file_fullname: file.file_fullname,
        file_name: file.file_name,
        file_type: file.file_type,
        file_size: file.file_size,
        extension: file.extension,
        is_image: file.is_image,
        is_resizable: file.is_resizable,
        // description: file.description,
        _joinData: {
          'id': file.id
        }
      });
      let imgHtml = '<img alt="';
      imgHtml += uploadedFile.file_name;
      imgHtml += '" src="';
      imgHtml += appConfig.apiUrl + appConfig.mediaFolder + '1920x1920_' + uploadedFile.file_fullname;
      imgHtml += '"/>';
      this._editor.execCommand('mceInsertContent', false, imgHtml);
      this._editor.windowManager.close();
    } else {
      this._alertService.error(ERROR_MESSAGE);
    }
  }

}
